import * as React from 'react';
import { KeyCodes } from 'office-ui-fabric-react/lib/Utilities';
import { observer } from 'mobx-react';
import { SurfaceFocusManager } from '../utils/SurfaceFocusManager';

export interface FocusManagedComponentProps {
    focusManager: SurfaceFocusManager;
}

/**
 * A component that injects the given focusManager's behaviors onto a div and sets the content inside of it, allowing for injecting
 * focusManager behavior onto arbitrary components
 *
 * on*Capture events come down during the capture phase of the browser event rather than the bubbling phase, so children can't accidentally
 * stopPropagation on them and prevent the focusManager from seeing that an event occurred in one of the children.
 * see https://javascript.info/bubbling-and-capturing
 */
@observer
export default class FocusManagedComponent extends React.Component<FocusManagedComponentProps, {}> {
    private boundEventHandlers: React.DOMAttributes<HTMLDivElement>;
    private eventHandlers: React.DOMAttributes<HTMLDivElement> = {
        onKeyDown: function(this: SurfaceFocusManager, evt: React.KeyboardEvent<HTMLDivElement>) {
            switch (evt.which) {
                case KeyCodes.tab:
                    this.onTab(evt);
                    break;
            }
        },
        onMouseDownCapture: function(
            this: SurfaceFocusManager,
            evt: React.MouseEvent<HTMLDivElement>
        ) {
            this.onMouseDown(evt);
        },
        onFocusCapture: function(this: SurfaceFocusManager, evt: React.FocusEvent<HTMLDivElement>) {
            if (
                evt.currentTarget &&
                evt.target.contains &&
                (evt.target == evt.currentTarget || evt.currentTarget.contains(evt.target))
            ) {
                this.onFocus(evt);
            }
        },
        onBlurCapture: function(this: SurfaceFocusManager, evt: React.FocusEvent<HTMLDivElement>) {
            this.onFocusOut(evt);
        },
    };

    UNSAFE_componentWillMount() {
        this.boundEventHandlers = this.props.focusManager.registerEventHandlers(this.eventHandlers);
    }

    render() {
        return React.cloneElement(
            <div />,
            {
                ...this.boundEventHandlers,
            },
            this.props.children
        );
    }
}
